import { EmptyState } from "@/components/ui/empty-state";
import { createFileRoute } from "@tanstack/react-router";
import { Scale } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/advisor/")({
	component: AdvisorIndex,
});

function AdvisorIndex() {
	const { t } = useTranslation("advisor");
	return (
		<div className="flex h-full items-center justify-center">
			<EmptyState
				icon={Scale}
				title={t("empty_title")}
				description={`${t("empty_description")} ${t("select_engagement")}`}
			/>
		</div>
	);
}
